import { type ReactNode } from 'react';

import { StickyFooter } from '../../../../../../../../components/ToolkitV2/StickyFooter/StickyFooter';

import * as Styled from './ActionsFooter.styled';

export const ActionsFooter = (props: { children: ReactNode }) => {
  return (
    <StickyFooter>
      <Styled.ActionsContainer>{props.children}</Styled.ActionsContainer>
    </StickyFooter>
  );
};
